import { useMutation } from "@tanstack/react-query";
import { useLocation, useNavigate } from "@tanstack/react-router";

import { privateApi } from "@/api/axios";
import { useToastStore } from "@/components";
import type { UpdateSubscriptionPayload } from "@/domains/subscriptions/models/types";

const updateSubscriptionStatus = async ({ action, careplanId }: UpdateSubscriptionPayload) => {
  await privateApi.post(`/careplans/${careplanId}/subscription/status`, { action });
};

export const useUpdateSubscriptionStatus = () => {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();
  const pushToast = useToastStore((state) => {
    return state.pushToast;
  });

  return useMutation({
    mutationFn: updateSubscriptionStatus,
    onSuccess: () => {
      navigate({
        to: pathname,
        search: {
          ...search,
          subscription_processing: true,
        },
        replace: true,
        resetScroll: false,
      });
    },
    onError: async (_error, { action }) => {
      await pushToast({
        type: "error",
        title: "Update Failed",
        message: `We couldn't ${action} your subscription. Please try again.`,
      });
    },
  });
};
